export function getRootDataClass(uuid: string, dataClasses) {
  const rootDataClasses = dataClasses
    .filter((dataClass) => dataClass.container === uuid)
    .map((dataClass) => dataClass.dataClass);

  return rootDataClasses[0];
}
